<template>
  <b-card
    :id="'notification-' + lead.code"
    :header-class="'d-none'"
    :class="['bg-white', 'lead-notification', 'cursor-pointer', {'lead-notification--priority': isPriority}, {'lead-notification--disabled' : soldOut}]"
    @click="openLead"
  >
    <template>
      <div class="row inner-wrap lead-notification__body">
        <div class="col-7 col-sm-8 text-left w-100 d-flex flex-column justify-content-between">
          <div>
            <span :class="{'font-weight-bold': isPriority}">
              {{ lead.enquiry.sold }}/{{ lead.enquiry.number_leads_requested }} {{ leadsSold(lead.enquiry.sold, lead.enquiry.number_leads_requested) }}
            </span>&nbsp;
            <br>
          </div>
          <div>
            <span class="h5">
              {{ lead.enquiry.work_type_description }}
            </span>
            <br>
            <span>
              {{ leadShortAddress(lead.enquiry.town, lead.enquiry.postcode) }}
            </span>
          </div>
        </div>
        <div class="priority col-5 col-sm-4 w-100 d-flex text-right flex-column justify-content-between">
          <div>
            <div v-if="isPriority" class="d-flex justify-content-end">
              <span class="text-left mr-2 text-primary font-weight-light priority__label" v-html="$t('Priority Access')" />
              <spinner small="true" />
            </div>
          </div>
          <div class="font-weight-light priority__time">
            {{ hoursPassed(lead.first_request) }}
          </div>
          <span v-if="!soldOut" class="delete-icon" @click.prevent.stop="dismissLead(lead)">
            <b-button class="close m-auto" variant="link">
              <font-awesome-icon icon="times" />
            </b-button>
          </span>
        </div>
      </div>
    </template>
  </b-card>
</template>

<script>
import LeadsSoldMixin from "@/imports/mixins/leadsSold";
import LeadShortAddressMixin from "@/imports/mixins/leadShortAddress";
import HoursPassed from "@/imports/mixins/hoursPassed";
import Spinner from "@/components/animation/Spinner";
import dates from "@/services/date";

export default {
  name: "LeadNotification",
  components: {Spinner},
  mixins:[LeadsSoldMixin,LeadShortAddressMixin, HoursPassed],
  props: ['lead'],
  computed: {
    isPriority: function() {
      return !dates.pastDate(this.lead.availability_guarantee_until);
    },
    soldOut: function() {
      return this.lead.enquiry.sold > 2
    }
  },
  methods: {
    openLead: function() {
      if (!this.soldOut) {
        this.$router.push({name:'buy-leads', query: {enquirycode: this.lead.enquiry.quote_code}})
        this.$eb.$emit('leadNotification-closeDropdown');
        this.$eb.$emit('leadNotification-loadNewEnquiry');
      }
    },
    dismissLead: function(lead) {
      this.$emit('hide', lead);
    },
  },
}
</script>

<style scoped lang="scss">
  .lead-notification {
    padding: 10px 20px;
    border-radius: .25rem;
    box-shadow: 0 .25rem .75rem rgba(0,0,0,.2);
    @include media-breakpoint-up(sm) {
      margin-bottom: 25px;
    }
    @include media-breakpoint-down(sm) {
      margin-bottom: 20px;
    }

    &__body {
      @include font-size($font-size-13);

      .icon {
        font-size: .5em !important;
        height: 11px;
        margin: 0 2px;
      }

      @include media-breakpoint-up(sm) {
        min-height: 75px;
      }
      @include media-breakpoint-down(sm) {
        min-height: 65px;
      }
    }

    &--priority {
      position: relative;
      &:before {
        content: '\200C';
        width: 8px;
        background: $theme-secondary-blue-800;
        height: 100%;
        left: 0;
        top: 0;
        position: absolute;
        border-top-left-radius: $input-border-radius;
        border-bottom-left-radius: $input-border-radius;
      }
    }
    &--disabled {
      opacity: .6;
      background-color: $white;
      font-style: italic;
      cursor: not-allowed !important;
      .lead-notification__body {
        background-color:  $white;
      }
    }
    .delete-icon {
      color: $theme-primary;
      position: absolute;
      top: -20px;
      @include media-breakpoint-up(md) {
        right: -14px;
      }
      @include media-breakpoint-down(sm) {
        right: -11px;
      }
      display: block;
      cursor: pointer;
    }
  }

  .priority {
    font-size: 12px;

    &__label {
      line-height: 1;
    }
  }

  ::v-deep {
    .ripple {
      &--small {
        width: 22px;
        height: 22px;
      }
      div {
        border-color: $theme-secondary-blue-800;
      }
    }
  }

  .close.btn {
    width: 20px;
    height: 20px;
    background: $white;
    padding: 1px;

    .svg-font--inline-fa {
      font-size: 0.6875em;
    }

    &:hover {
      background: $theme-primary;
    }
  }
</style>
